import { z } from 'zod'

// =====================
// Task→ticket status sync config
// =====================
//
// Stored in TicketTypeDef.taskSyncConfig (Json). Governs how a ticket follows
// the tasks it was promoted/split to (linked via ModuleReference TICKET→TASK):
//   - onAnyTaskActive: stage when any linked task moves to IN_PROGRESS
//   - onAllTasksCompleted: stage when every linked task is COMPLETED
//   - onTaskReopened: stage when a resolved ticket's task is reopened
//     (moved off COMPLETED without anything actively in progress)
// Key semantics: absent → category-matched default stage for that event;
// explicit null → that event never moves the ticket; a stageId that no longer
// exists in the type's effective stage set falls back to the category default.
// A ticket resolves only when EVERY linked, non-deleted, non-canceled task is
// complete. CLOSED tickets are terminal and never moved by sync.
export const TicketTaskSyncConfigSchema = z.object({
  // Default true — an empty config keeps sync on with category defaults.
  enabled: z.boolean().optional(),
  onAnyTaskActive: z.string().max(50).nullable().optional(),
  onAllTasksCompleted: z.string().max(50).nullable().optional(),
  onTaskReopened: z.string().max(50).nullable().optional(),
})

export type TicketTaskSyncConfig = z.infer<typeof TicketTaskSyncConfigSchema>
